import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-get-feedback',
  templateUrl: './get-feedback.component.html',
  styleUrls: ['./get-feedback.component.scss'],
})
export class GetFeedbackComponent{
  items:any=[];
  loader:boolean=false;
  search;
  editId;
  orgObj: any;
  orgName;
  orgId = localStorage.getItem('organizationId');
  newOrgObject;
  create:boolean;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService, private bottomSheet: MatBottomSheet) { }
  ionViewWillEnter() {
     this.loader=true;
    this.orgId = localStorage.getItem('organizationId');
    this.orgObj=JSON.parse(localStorage.getItem('capabilityOrg'));
    let obj=[];
        this.service.getfeedbackOrg(this.orgId).subscribe(res=>{
        this.items = res;
        if(this.items){
          this.items = this.items.filter(res => res.type == 2);
          }
          else{
            this.handler.res("No Feedbacks For You");
          }
        this.loader = false;
      },err=>{
        this.loader = false;
        this.handler.err(err)
      })
     
    }
  
    edit(id){
      this.router.navigate(['/edit-feedback',id]);
    }
    openBottomSheetOrg(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
        data: this.items,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if(res){
        this.orgName = res.name;
        this.orgId = res.id;
        this.loader = true;
        this.service.getfeedbackOrg(this.orgId).subscribe(res=>{
          this.items = res;
          if(this.items){
            this.items = this.items.filter(res => res.type == 2);
            }
            else{
              this.items=[];
              this.handler.res("No Feedbacks For you");
            }
          this.loader = false;
        },err=>{
          this.loader = false;
          this.handler.err(err)
        })
       } }); 
    }
  
    ionViewWillLeave(){
      this.search ="";
    }

}
